import React from 'react';
import LoginForm from '../components/LoginPage/LoginForm';

const Login = () => {
    return <LoginForm />;
};

export default Login;
